// bycursor-start
/**
 * Layout contexts shared outside of the component file.
 * bycursor
 */
import { noop } from 'lodash-es';
import { createContext } from 'react';

import type { PageConfigCompContext, PageConfigContext } from './interface';

export const LayoutContext = createContext<PageConfigContext>(noop);

export const LayoutCompContext = createContext<PageConfigCompContext>({
  getPageConfig: noop,
  updatePageConfig: noop,
});
// bycursor-end

// Contains cursor-generated edits.
